import { ComponentCategory, PropType, type ComponentMeta } from "@mijalowcode/types";

const DEFAULT_IMAGE_SOURCE = "https://placehold.co/300x200?text=Image";
const DEFAULT_IMAGE_WIDTH = "100%";
const DEFAULT_IMAGE_HEIGHT = "auto";

export const ImageMeta: ComponentMeta = {
  componentName: "Image",
  package: "@mijadesign/mjui-react",
  title: "图片",
  category: ComponentCategory.DATA_DISPLAY,
  visibleInComponentPanel: true,
  canHaveChildren: false,
  npm: {
    package: "@mijadesign/mjui-react",
    exportName: "Image",
  },
  docLinks: [
    {
      title: "移动端组件库 Image",
      url: "https://frontend.mishudata.com/uigallery/iframe.html?key=mobile/doc",
      source: "mijadesign",
    },
  ],
  eventSources: [
    {
      name: "click",
      label: "点击",
      trigger: "dom",
    },
  ],
  props: [
    {
      name: "src",
      label: "图片地址",
      type: PropType.STRING,
      defaultValue: DEFAULT_IMAGE_SOURCE,
      group: "内容",
    },
    {
      name: "alt",
      label: "替代文本",
      type: PropType.STRING,
      defaultValue: "",
      group: "内容",
    },
    {
      name: "width",
      label: "宽度",
      type: PropType.STRING,
      defaultValue: DEFAULT_IMAGE_WIDTH,
      group: "样式",
    },
    {
      name: "height",
      label: "高度",
      type: PropType.STRING,
      defaultValue: DEFAULT_IMAGE_HEIGHT,
      group: "样式",
    },
    {
      name: "fit",
      label: "填充方式",
      type: PropType.ENUM,
      defaultValue: "cover",
      options: [
        { label: "裁剪填充", value: "cover" },
        { label: "完整显示", value: "contain" },
        { label: "拉伸填充", value: "fill" },
        { label: "原始尺寸", value: "none" },
        { label: "缩小适配", value: "scale-down" },
      ],
      group: "样式",
    },
    {
      name: "position",
      label: "图片位置",
      type: PropType.ENUM,
      defaultValue: "center",
      options: [
        { label: "居中", value: "center" },
        { label: "顶部", value: "top" },
        { label: "底部", value: "bottom" },
        { label: "左侧", value: "left" },
        { label: "右侧", value: "right" },
      ],
      group: "样式",
    },
    {
      name: "radius",
      label: "圆角",
      type: PropType.NUMBER,
      defaultValue: 0,
      group: "样式",
    },
    {
      name: "lazy",
      label: "懒加载",
      type: PropType.BOOLEAN,
      defaultValue: false,
      group: "功能",
    },
    {
      name: "draggable",
      label: "允许拖拽",
      type: PropType.BOOLEAN,
      defaultValue: true,
      group: "功能",
    },
  ],
  defaultProps: {
    src: DEFAULT_IMAGE_SOURCE,
    alt: "",
    width: DEFAULT_IMAGE_WIDTH,
    height: DEFAULT_IMAGE_HEIGHT,
    fit: "cover",
    position: "center",
    radius: 0,
    lazy: false,
    draggable: true,
  },
  snippet: {
    componentName: "Image",
    package: "@mijadesign/mjui-react",
    props: {
      src: DEFAULT_IMAGE_SOURCE,
      alt: "",
      width: DEFAULT_IMAGE_WIDTH,
      height: DEFAULT_IMAGE_HEIGHT,
      fit: "cover",
      position: "center",
      radius: 0,
      lazy: false,
      draggable: true,
    },
  },
};
